"use strict";require("core-js/modules/es.array.slice");require("core-js/modules/es.regexp.exec");require("core-js/modules/es.string.replace");require("core-js/modules/es.string.trim");exports.__esModule = true;exports.clearWS = clearWS;exports.randStr = randStr;exports.castStr = castStr;exports.cropStr = cropStr;exports.clearNonDigits = clearNonDigits;exports.clearNonAlphanumeric = clearNonAlphanumeric;exports.clearNonWord = clearNonWord;exports.clearDigits = clearDigits;exports.capitalizeStr = capitalizeStr;

var _is = require("./is");
var _num = require("./num");

/**
                              * @namespace __String
                              */


var spacesRegex = /\s+/g;
/**
                           * Тримит строку и сокращает число пробелов до одного в середине строки
                           *
                           *
                           * @param {string} str "  ab   c  "
                           * @returns {string} "ab c"
                           * @memberof __String
                           */
function clearWS(str) {
  return str.replace(spacesRegex, ' ').trim();
}

/**
   * Возвращает рандомную строку вида \d+\-random
   *
   *
   * @returns {string} "1345234523452-random"
   * @memberof __String
   */
function randStr() {
  return (0, _num.randNum)() + "-random";
}






/**
   * Возвращает переданный аргумент, если он является строкой,
   * либо второй аргумент (если он присутствует и также является строкой ),
   * либо пустую строку
   *
   *
   * @param {mixed} maybeStr
   * @param {?string} defaultStr
   * @returns {string}
   * @memberof __String
   */
function castStr(maybeStr, defaultStr) {
  if ((0, _is.isStr)(maybeStr)) return maybeStr;
  return (0, _is.isStr)(defaultStr) ? defaultStr : '';
}





/**
   * Обрезает строку до указанной длины если `maxLength` - число и больше нуля
   *
   *
   * @param {string} strIn
   * @param {(number | null)} maxLength
   * @returns {string}
   * @memberof __String
   */
function cropStr(strIn, maxLength) {
  var str = castStr(strIn);
  if (
  (0, _is.isNum)(maxLength) &&
  maxLength > 0 &&
  str.length > maxLength)
  {
    str = str.slice(0, maxLength);
  }
  return str;
}


var nonDigitsRegex = /\D+/g;
/**
                              * Очищает все нечисловые символы
                              *
                              *
                              * @param {string} str
                              * @returns {string}
                              * @memberof __String
                              */
function clearNonDigits(str) {
  return str.replace(nonDigitsRegex, '');
}



var nonAlphanumericRegex = /\W+/g;
/**
                                    * Очищает символы не входящие в паттерн [A-Za-z0-9_]
                                    *
                                    *
                                    * @param {string} str
                                    * @returns {string}
                                    * @memberof __String
                                    */
function clearNonAlphanumeric(str) {
  return str.replace(nonAlphanumericRegex, '');
}




var nonWordRegex = /\W+|\d+|_+/g;
/**
                                   * Очищает символы не буквенные символы
                                   *
                                   *
                                   * @param {string} str
                                   * @returns {string}
                                   * @memberof __String
                                   */
function clearNonWord(str) {
  return str.replace(nonWordRegex, '');
}



var digitsRegex = /\d+/g;
/**
                           * Очищает все числовые символы
                           *
                           *
                           * @param {string} str
                           * @returns {string}
                           * @memberof __String
                           */
function clearDigits(str) {
  return str.replace(digitsRegex, '');
}

/**
   * Переводит первый символ строки в верхний регистр, остальные — в нижний
   *
   *
   * @param {string} str
   * @returns {string}
   * @memberof __String
   */
function capitalizeStr(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/str.js
// module id = 127
// module chunks = 0